import { render, staticRenderFns } from "./resultview.vue?vue&type=template&id=1ea1d1b2&scoped=true&"
import script from "./resultview.vue?vue&type=script&lang=js&"
export * from "./resultview.vue?vue&type=script&lang=js&"
import style0 from "./resultview.vue?vue&type=style&index=0&id=1ea1d1b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea1d1b2",
  null
  
)

export default component.exports